import { createFileRoute } from "@tanstack/react-router";

import { ProjectDetail } from "../projects/ProjectDetail";
import { projectDetailQueryOptions } from "../projects/queries";

export const Route = createFileRoute("/_auth/projects/$projectId")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      projectDetailQueryOptions(params.projectId),
    ),
  component: ProjectDetailRoute,
});

function ProjectDetailRoute() {
  const { projectId } = Route.useParams();
  return <ProjectDetail projectId={projectId} />;
}
